"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogLayoutSide = void 0;
var React = __importStar(require("react"));
var icons_1 = require("@epic-ui/icons");
var DialogLayoutBase_1 = require("./DialogLayoutBase");
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var styles_1 = require("@material-ui/core/styles");
var DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var clsx_1 = __importDefault(require("clsx"));
var styles_2 = require("../../styles");
var ReturnButton = styles_1.styled(IconButton_1.default)(function (_a) {
    var spacing = _a.theme.spacing;
    return ({
        position: "absolute",
        left: spacing(3),
        top: spacing(7),
    });
}, { name: "EuiReturnButton" });
var useStyles = styles_1.makeStyles(styles_2.sideDialogBaseStyles);
var DialogLayoutSide = function (_a) {
    var dialogTitle = _a.dialogTitle, _b = _a.DialogTitleProps, _c = _b === void 0 ? { disableTypography: false } : _b, disableTypography = _c.disableTypography, // Intercept prop to replace typography
    DialogTitleProps = __rest(_c, ["disableTypography"]), onClickReturn = _a.onClickReturn, ReturnButtonProps = _a.ReturnButtonProps, onClose = _a.onClose, displayClose = _a.displayClose, onClickClose = _a.onClickClose, CloseButtonProps = _a.CloseButtonProps, children = _a.children, DialogContentProps = _a.DialogContentProps, dialogActions = _a.dialogActions, DialogActionsProps = _a.DialogActionsProps, TitleTypographyProps = _a.TitleTypographyProps;
    var classes = useStyles();
    var hasDialogTitle = Boolean(dialogTitle || displayClose || onClickReturn);
    return (React.createElement(React.Fragment, null,
        hasDialogTitle && (React.createElement(DialogLayoutBase_1.DialogTitle, __assign({}, DialogTitleProps, { className: clsx_1.default(classes.title, DialogTitleProps.className) }),
            onClickReturn && (React.createElement(ReturnButton, __assign({ size: "small", onClick: onClickReturn }, ReturnButtonProps),
                React.createElement(icons_1.ArrowStrokeLeft, null))),
            React.createElement(DialogLayoutBase_1.DialogTitleBody, null, disableTypography ? (dialogTitle) : (React.createElement(Typography_1.default, __assign({ variant: "h4", component: "h2", color: "textPrimary" }, TitleTypographyProps), dialogTitle))),
            displayClose && (React.createElement(IconButton_1.default, __assign({ size: "small", onClick: onClickClose || (function (e) { return onClose && onClose(e, "backdropClick"); }) }, CloseButtonProps),
                React.createElement(icons_1.Close, null))))),
        children && (React.createElement(DialogContent_1.default, __assign({}, DialogContentProps, { className: clsx_1.default(classes.content, DialogContentProps === null || DialogContentProps === void 0 ? void 0 : DialogContentProps.className) }), children)),
        dialogActions && (React.createElement(DialogActions_1.default, __assign({}, DialogActionsProps, { className: clsx_1.default(classes.actions, DialogActionsProps === null || DialogActionsProps === void 0 ? void 0 : DialogActionsProps.className) }), dialogActions))));
};
exports.DialogLayoutSide = DialogLayoutSide;
//# sourceMappingURL=DialogLayoutSide.js.map